<template>
    <span>

    <header id="header">
    <div class="container">

      <div id="logo" class="pull-left">
         <b-link class="navbar-brand" to="/externa">
        <h5 class="navbar-brand-full" width="50" height="25" alt="SINDH Desaparecidos">Mães do Brasil</h5>
      </b-link>
      </div>
    </div>
  </header>

      <main id="main">
        <section id="schedule" class="section-with-bg">
            <br><br><br>
            <div class="container wow fadeInUp">
              <div class="section-header">
              <h2>Seu acesso não foi autorizado!</h2>
            </div>

                <div class="tab-content row justify-content-center">
                    <div role="tabpanel" class="col-lg-11 tab-pane fade show active" id="day-1">
                          <video controls id="video1" style="width: 100%; height: auto; margin:0 auto; frameborder:0;">
                             <source :src="$api1 + '/videos/video-inicial.mp4'" type="video/mp4">
                          </video>
                    </div>
                </div>
            </div>
        </section>
      </main>

      <footer id="footer">
        <div class="container">
            <div class="copyright">&copy; Copyright <strong>SINDH Desaparecidos</strong></div>
        </div>
      </footer>

      <a href="#" class="back-to-top"><i class="fa fa-angle-up"></i></a>
    </span>
</template>

<script>
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'

export default {
  name: 'SiteTemplate',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
    }
  },
  mounted () {
    $('#barraBrasilCustom').show()
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  methods: {
    redirect: function () {
      this.$router.push('/captcha-externa')
    }
  }
}
</script>

<style lang="scss">
    // CoreUI Icons Set
    @import '@coreui/icons/css/coreui-icons.min.css';
    /* Import Font Awesome Icons Set */
    $fa-font-path: '~font-awesome/fonts/';
    @import '~font-awesome/scss/font-awesome.scss';
    /* Import Simple Line Icons Set */
    $simple-line-font-path: '~simple-line-icons/fonts/';
    @import '~simple-line-icons/scss/simple-line-icons.scss';
    /* Import Flag Icons Set */
    @import 'flag-icon-css/css/flag-icon.min.css';
    /* Import Bootstrap Vue Styles */
    @import 'bootstrap-vue/dist/bootstrap-vue.css';
    // Import Main styles for this application
    @import '../../assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/templates/site-externo/CaptchaErro.vue